import { navbar_profile_utils_methods } from './navbar_profile_utils_methods';
import { navbar_profile_validation_methods } from './navbar_profile_validation_methods';
import { navbar_profile_drive_methods } from './navbar_profile_drive_methods';
import { navbar_profile_fetch_methods } from './navbar_profile_fetch_methods';
import { navbar_profile_save_methods } from './navbar_profile_save_methods';

export const navbar_profile_methods = {
  ...navbar_profile_utils_methods,
  ...navbar_profile_validation_methods,
  ...navbar_profile_drive_methods,
  ...navbar_profile_fetch_methods,
  ...navbar_profile_save_methods,
};
